"use strict";
define([
        'vue'
    ],
    function (Vue) {
        /**
         * 글로벌 컴포넌트: 페이지네이션(cc-table과 독립된 기능)
         */
        Vue.component('pagination', {
            template: "\
                <div class='pagination-wrap' v-if='num_of_pages'>\
                    <ul class='pagination'>\
                        <!-- 이전 묶음으로 -->\
                        <li v-if='page > num_of_buttons' class='chunk-prev'>\
                            <a @click='page=last_page_in_prev_chunk' v-html='chunk_prev_button'></a>\
                        </li>\
                        <!-- 1페이지로 가기 -->\
                        <li v-if='page > num_of_buttons'>\
                            <a @click='page=1'>1</a>\
                        </li>\
                        <li class='begin-end-page-symbol' v-if='page > num_of_buttons'>\
                            <a>···</a>\
                        </li>\
                        \
                        <!-- 페이지 숫자 리스트 -->\
                        <li v-for='(p, i) in pages_in_current_chunk' \
                            :class=\"{active:page===p}\">\
                            <a @click='page=p'\>{{p}}</a>\
                        </li>\
                        \
                        <li class='begin-end-page-symbol' v-if='num_of_pages && !is_last_chunk'>\
                            <a>···</a>\
                        </li>\
                        <li v-if='num_of_pages && !is_last_chunk'>\
                            <a @click='page=num_of_pages'>{{num_of_pages}}</a>\
                        </li>\
                        <!-- 다음 묶음으로 -->\
                        <li v-if='!is_last_chunk' class='chunk-next'>\
                            <a @click='page=first_page_in_next_chunk' v-html='chunk_next_button'></a>\
                        </li>\
                    </ul>\
                </div>\
            ",
            props   : {
                page        : {
                    type    : Number,
                    required: true,
                    default : 1
                },
                num_per_page: {
                    type    : Number,
                    required: true
                },
                // 표시할 버튼 수
                num_of_buttons: {
                    type    : Number,
                    required: false,
                    default : 10
                },
                total         : {
                    type    : Number,
                    required: true
                },
                chunk_prev_button   : {
                    type    : String,
                    required: false,
                    default : '<'
                },
                chunk_next_button   : {
                    type    : String,
                    required: false,
                    default : '>'
                },
            },
            watch   : {
                // 컴포넌트 내부에서 현재 페이지를 바꾸는 경우
                page: function () {
                    this.$emit('page_changed', this.page);
                }
            },
            computed: {
                pages_in_current_chunk: function () {
                    var pages = [];
                    for (var i = this.first_page_in_current_chunk; i <= this.last_page_in_current_chunk; i++)
                    {
                        pages.push(i);
                    }
                    return pages;
                },
                // 마지막 페이지. total 이 없을 경우 undefined
                num_of_pages               : function () {
                    if (!this.total)
                    {
                        return undefined;
                    }
                    return Math.ceil(this.total / this.num_per_page);
                },
                num_of_chunks              : function () {
                    if (typeof this.num_of_pages === "undefined")
                    {
                        return undefined;
                    }
                    return Math.ceil(this.num_of_pages / this.num_of_buttons);
                },
                current_chunk              : function () {
                    return Math.ceil(this.page / this.num_of_buttons);
                },
                is_last_chunk              : function () {
                    if (!this.num_of_chunks) // 전체 레코드 수에 대한 정보가 없으면 계산 불가
                    {
                        return false;
                    }
                    return this.current_chunk === this.num_of_chunks;
                },
                first_page_in_current_chunk: function () {
                    return (this.current_chunk - 1) * this.num_of_buttons + 1;
                },
                last_page_in_current_chunk : function () {
                    if (this.num_of_pages)
                    {
                        return Math.min(this.num_of_pages, this.current_chunk * this.num_of_buttons);
                    }
                    return this.current_chunk * this.num_of_buttons;
                },
                first_page_in_next_chunk   : function () {
                    return this.last_page_in_current_chunk + 1;
                },
                last_page_in_prev_chunk    : function () {
                    return this.first_page_in_current_chunk - 1;
                }
            }
        });
    });